import type { Reducer } from 'redux';
import type { FuelSavingState } from '../types';
import { initialState } from '../types';
import {
    FUEL_SAVING_CANCEL,
    FUEL_SAVING_OPEN,
    FUEL_SAVING_RESET,
    SET_VEHICLE_TABS,
    SET_SCENARIO_LOAD_SETTLED,
    FETCH_FUEL_ECONOMY_SUCCESS,
    FETCH_FUEL_ECONOMY_FAILURE
} from './actions';

export type FuelSavingReducer = Reducer<FuelSavingState, any>;

// Placeholder reducer: keep state empty for now until feature behavior is finalized.
export const fuelSavingReducer: FuelSavingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FUEL_SAVING_OPEN: {
            return { ...state, isFuelSavingCardState: true };
        }
        case SET_VEHICLE_TABS: {
            return { ...state, vehicleTabs: action.payload };
        }
        case SET_SCENARIO_LOAD_SETTLED: {
            return { ...state, isScenarioLoadSettled: action.payload };
        }
        case FUEL_SAVING_CANCEL: {
            // Only close the slideout, preserve vehicleTabs data for reopen
            return { ...state, isFuelSavingCardState: false };
        }
        case FUEL_SAVING_RESET: {
            // Full reset clears everything including vehicleTabs
            return initialState;
        }
        case FETCH_FUEL_ECONOMY_SUCCESS: {
            return { ...state, fuelEconomyData: action.payload ?? null };
        }
        case FETCH_FUEL_ECONOMY_FAILURE: {
            return { ...state, fuelEconomyData: null };
        }
        default: {
            return state;
        }
    }
};
